import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class FiltresSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameimages: [0]
  }
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    //alert(event.target.name);
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }
 
  // #endregion
  render() {
    const { config } = this.props;
    console.log('SMSsetting');
    console.log(config);
    const gamable = (config.Filtres )? (
      <Input
        checked
        type="checkbox"
        name="Filtres"
        id="Filtres"
        onChange={this.handleCheckboxChange}
      />
    ) : (
      <Input
        type="checkbox"
        name="Filtres"
        id="Filtres"
        onChange={this.handleCheckboxChange}
      />
    );
    return (
      <Section title="Filtres settings">
        <FormGroup row className="d-flex justify-content-center">
        <Label  className="ml-2" sm={2}>
            <Col>       
             {gamable}Activate(Filtres)
             </Col>               
          </Label>
          
        </FormGroup>
       
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltresSetting);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/FiltresSettings.jsx